export default "__VITE_ASSET__Cm0xubQ9__"